import { Routes } from '@angular/router';
import { AuthGuard, AdminGuard } from './guards/auth.guard';
import { IosComingSoonGuard } from './guards/ios-coming-soon.guard';
import { ResetPasswordComponent } from './pages/auth/reset-password.component';
import { CriticalContacts } from './pages/Beneficiary-Access/home/modules/critical-contacts/critical-contacts';
import { ChecklistComponent } from './pages/Beneficiary-Access/home/modules/checklist/checklist';
import { Layout } from './pages/Beneficiary-Access/home/layout/layout';
import { MemoriesStoriesComponent } from './pages/Beneficiary-Access/home/modules/memories-stories/memories-stories';
import { ContactAdminComponent } from './pages/Beneficiary-Access/home/modules/contact-admin/contact-admin';
import { ReportPassingComponent } from './pages/Beneficiary-Access/home/modules/report-passing/report-passing';


export const routes: Routes = [
  { 
    path: '', 
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
 path:'payment-success',
 loadComponent:()=>import('./pages/auth/payment-success.component')
 .then(m => m.PaymentSuccessComponent)
},

//   {
//   path: 'dashboard/quick-action',
//   loadComponent: () =>
//     import('./pages/dashboard/quick-action/quick-action')
//       .then(m => m.QuickActionComponent)
// },

  { 
    path: 'login', 
    loadComponent: () => import('./pages/auth/login.component').then(m => m.LoginComponent)
  },

  { 
    path: 'forgot-password', 
    loadComponent: () => import('./pages/auth/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },

  { 
    path: 'reset-password', 
    loadComponent: () => import('./pages/auth/reset-password.component').then(m => m.ResetPasswordComponent)
  },

  { 
    path: 'verify-email', 
    loadComponent: () => import('./pages/auth/verify-email.component').then(m => m.VerifyEmailComponent)
  },

  {
    path: 'getting-started',
    loadComponent: () => import('./pages/auth/getting-started.component').then(m => m.GettingStartedComponent),
    canActivate: [IosComingSoonGuard]
  },
  {
    path: 'renew-subscription',
    loadComponent: () => import('./pages/auth/renew-subscription.component').then(m => m.RenewSubscriptionComponent),
    canActivate: [AuthGuard, IosComingSoonGuard]
  },

  { 
    path: 'payment-success', 
    loadComponent: () => import('./pages/auth/payment-success.component').then(m => m.PaymentSuccessComponent),
    canActivate: [AuthGuard]
  },

  { 
    path: 'dashboard', 
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard]
  },

  { 
    path: 'profile', 
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [AuthGuard]
  },

  // Admin routes
  { 
    path: 'admin/login', 
    loadComponent: () => import('./pages/admin/admin-login.component').then(m => m.AdminLoginComponent)
  },

  { 
    path: 'admin/dashboard', 
    loadComponent: () => import('./pages/admin/admin-dashboard.component').then(m => m.AdminDashboardComponent),
    canActivate: [AdminGuard]
  },

  { 
    path: 'admin/users', 
    loadComponent: () => import('./pages/admin/admin-users.component').then(m => m.AdminUsersComponent),
    canActivate: [AdminGuard]
  },
{
  path: 'admin/transactions',
  loadComponent: () =>
    import('./pages/admin/admin-transactions/admin-transactions')
      .then(m => m.AdminTransactionsComponent),
  canActivate: [AdminGuard]
},
{
  path: 'admin/support-requests',
  loadComponent: () =>
    import('./pages/admin/admin-support-request/admin-support-request')
      .then(m => m.AdminSupportRequestsComponent),
  canActivate: [AdminGuard]
},
{
  path: 'admin/communication',
  loadComponent: () =>
    import('./pages/admin/admin-communication/admin-communication')
      .then(m => m.AdminCommunicationComponent),
  canActivate: [AdminGuard]
},
{
  path: 'admin/pricing-master',
  loadComponent: () =>
    import('./pages/admin/admin-pricing-master/admin-pricing-master')
      .then(m => m.AdminPricingMasterComponent),
  canActivate: [AdminGuard]
},
  { 
    path: 'reset-password', 
    loadComponent: () => import('./pages/auth/reset-password.component').then(m => m.ResetPasswordComponent)
  },
//   {
//   path: '',
//   component: ResetPasswordComponent
// },

  { 
    path: 'admin/users/:id', 
    loadComponent: () => import('./pages/admin/admin-user-detail.component').then(m => m.AdminUserDetailComponent),
    canActivate: [AdminGuard]
  },

  // Legal pages
  { 
    path: 'terms', 
    loadComponent: () => import('./pages/legal/terms _of_services.component').then(m => m.TermsofServicesComponent)
  },

  { 
    path: 'cookie-policy', 
    loadComponent: () => import('./pages/legal/cookie_policy.component').then(m => m.CookiePolicyComponent)
  },

  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/legal/privacy_policy.component').then(m => m.PrivacyPolicyComponent)
  },

  /* ONLY FIX THIS BENEFICIARY ROUTING BLOCK */

{
  path: 'beneficiary-home',
  canActivate: [AuthGuard],
  loadComponent: () =>
    import('./pages/Beneficiary-Access/home/home')
      .then(m => m.DashboardComponent)
},
{
  path: 'beneficiary/accept-invite',
  loadComponent: () =>
    import('./pages/Beneficiary-Access/accept-invite/accept-invite').then(
      m => m.AcceptInviteComponent
    )
},

{
  path: 'beneficiary-layout',
  component: Layout,
  canActivate: [AuthGuard],

  children: [

    {
      path: 'critical-contacts',
      component: CriticalContacts
    },

    {
      path: 'checklist',
      component: ChecklistComponent
    },
    {
      path: 'memories-stories',
      component: MemoriesStoriesComponent
    },
    {
      path: 'contact-admin',
      component: ContactAdminComponent
    },
    {
      path: 'report-passing',
      component: ReportPassingComponent
    }
   
  ]
},


  // Catch all
  { path: '**', redirectTo: '' }
];